var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Top"),
      _vm._v(" "),
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm" }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-md-6" },
            [
              _c("br"),
              _vm._v(" "),
              _c("Pagination", {
                attrs: { numberOfDots: 4, numberOfVisitedDots: 4 }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "margin-top-75" }),
              _vm._v(" "),
              !_vm.message
                ? _c("div", [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("div", { staticClass: "clearfix" }),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "Sidan du letar efter är inte tillgänglig för tillfället eller så är det kanske ett problem med länken du har klickat på."
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", [_vm._v("Vi ber om ursäkt för besväret.")])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.message && _vm.$attrs.type === "login"
                ? _c("div", [
                    _c("img", {
                      staticClass: "img-fluid",
                      staticStyle: { padding: "20px" },
                      attrs: {
                        src: require("@/assets/img/lock.svg?data"),
                        alt: "Bild på ett hänglås"
                      }
                    }),
                    _vm._v(" "),
                    _vm._m(1),
                    _vm._v(" "),
                    _c(
                      "p",
                      [
                        _vm._v(
                          "Ta kontakt med den som skulle bjudit in dig eller\n            "
                        ),
                        _c(
                          "router-link",
                          { attrs: { to: "faq/contact", target: "_blank" } },
                          [_vm._v("supporten")]
                        ),
                        _vm._v(" om felet kvarstår.\n          ")
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.message && _vm.$attrs.type === "referral"
                ? _c("div", [
                    _vm._m(2),
                    _vm._v(" "),
                    _c("div", { staticClass: "clearfix" }),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.specificError))]),
                    _vm._v(" "),
                    _c("p", [_vm._v("Gå tillbaka och välj en annan stad.")])
                  ])
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm" }),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary btn-lg btn-block",
                on: {
                  click: function($event) {
                    return _vm.$router.push("/")
                  }
                }
              },
              [_vm._v("Till startsidan")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm" })
        ])
      ]),
      _vm._v(" "),
      _c("Bottom")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-wrapper" }, [
      _c("h1", { staticClass: "text-danger left-header" }, [
        _vm._v("Ett fel har inträffat!")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-wrapper" }, [
      _c("h2", { staticClass: "text-danger left-header" }, [
        _vm._v("Det verkar som att du inte har inloggningsbehörighet.")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-wrapper" }, [
      _c("h1", { staticClass: "text-danger left-header" }, [
        _vm._v("Det gick inte att skapa remiss.")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-026a7a08", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-026a7a08","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Error.vue
// module id = null
// module chunks = 